import { render, staticRenderFns } from "./teacherTextbook.vue?vue&type=template&id=0690bc18&scoped=true&"
import script from "./teacherTextbook.vue?vue&type=script&lang=js&"
export * from "./teacherTextbook.vue?vue&type=script&lang=js&"
import style0 from "./teacherTextbook.vue?vue&type=style&index=0&id=0690bc18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690bc18",
  null
  
)

export default component.exports